import { ComponentType } from "react";
import StepCollectInfo from "./StepCollectInfo";
import StepColors from "./StepColors";
import StepFonts from "./StepFonts";
import StepStyles from "./StepLayoutStyles";
import { POSOnboardSetup } from "../useApplyOnboardSetup";
import { ValidationResult } from "../Onboard";

export const OnboardStepsIndex: {
    id: string;
    component: ComponentType<{
        posOnboardSetup: POSOnboardSetup;
        setPOSOnboardSetup: any;
        setValidateCurrentStep?: (validate: () => ValidationResult) => void;
    }>;
    shortDescription: string;
}[] = [
    {
        id: "colors",
        component: StepColors,
        shortDescription: "Let’s set up how your POS looks and feels"
    },
    {
        id: "styles",
        component: StepStyles,
        shortDescription: "Let’s set up how your POS looks and feels"
    },
    {
        id: "fonts",
        component: StepFonts,
        shortDescription: "Let’s set up how your POS looks and feels"
    },
    {
        id: "collect-info",
        component: StepCollectInfo,
        shortDescription: "Tell us a bit about yourself"
    }
];
